__turbopack_context__.v({
  "loadingGradient": "InAppAgentWindow-module__2qMl6q__loadingGradient",
  "rotate-loading-gradient": "InAppAgentWindow-module__2qMl6q__rotate-loading-gradient",
});
